export const PROCESS_ASSISTANT_GUIDES = [
  {
    id: "process-blueprint",
    title: "Desenho rápido de processos",
    summary:
      "Transforma descrições de objetivos em etapas BPMN com responsáveis, SLAs aproximados e formulário inicial.",
    keywords: ["processo", "assistente", "etapas", "sla", "bpmn"],
    promptExamples: [
      "Fluxo de compras com aprovação financeira e integração contábil",
      "Processo de admissões com checklist documental e comunicação ao RH",
    ],
    steps: [
      "Abrir o Assistente IA na tela de processos e preencher o prompt principal.",
      "Opcionalmente anexar documentos para contextualizar o fluxo.",
      "Revisar etapas sugeridas, tempos e formulário inicial antes de salvar como rascunho.",
    ],
    insights: [
      "Ajustes realizados após a geração alimentam o histórico utilizado pelo assistente do Studio.",
    ],
  },
  {
    id: "process-analysis",
    title: "Análises inteligentes",
    summary:
      "A partir de um processo existente, a IA gera insights de gargalos, automações sugeridas e próximos passos.",
    keywords: ["analise", "gargalo", "automacao", "melhoria"],
    promptExamples: [
      "Analisar o processo de reembolso e sugerir melhorias",
      "Quais etapas do processo de vendas podem ser automatizadas?",
    ],
    steps: [
      "Selecionar um processo publicado e usar a ação Analisar com IA.",
      "Consultar o resumo com indicadores, automações sugeridas e recomendações de SLA.",
      "Exportar as sugestões ou aplicar ajustes diretamente no modelador.",
    ],
    insights: [
      "Os relatórios consideram volume de etapas, responsáveis e campos obrigatórios para recomendar otimizações.",
    ],
  },
  {
    id: "process-document-import",
    title: "Importação guiada",
    summary:
      "Envie contratos, fluxogramas ou planilhas para gerar processos baseados em documentos existentes.",
    keywords: ["documento", "importacao", "contrato", "planilha", "upload"],
    promptExamples: [
      "Gerar processo a partir do manual operacional de atendimento",
      "Converter planilha de controle de propostas em fluxo BPM",
    ],
    steps: [
      "Selecionar arquivo no Assistente IA e complementar com contexto no prompt.",
      "Validar o conteúdo reconhecido no preview antes de gerar o fluxo.",
      "Abrir o processo sugerido no modelador para personalizar gateways e responsáveis.",
    ],
    insights: [
      "Documentos com tópicos numerados ajudam o assistente a identificar etapas sequenciais com mais precisão.",
    ],
  },
];
